import axios from 'axios';
 
class AccountService { 
  getAccountDetails() { 
    return axios.get(`hacker/details`); 
  }
  putAccountHacker(payload) { 
    return axios.put(`hacker`,payload); 
  }
  getAccountMy() { 
    return axios.get(`account/my`); 
  }
  getAuditSessions() {
    return axios.get(`account/audit/sessions`); 
  } 
  getAuthentication() {
    return axios.get(`account/authentication`); 
  } 
  async get2fa() {
    return axios.get(`account/2fa/generate`) 
  } 
  put2faTurnOn(payload) {
    return axios.put(`account/2fa/turn-on`,payload)  
  } 
  put2faTurnoff(payload) {
    return axios.put(`account/2fa/turn-off`,payload)  
  } 
  postKeysGenerate() {
    return axios.post(`account/recovery_keys/generate`)  
  } 
  postPhoneValidation(payload) {
    return axios.post(`account/phone_validation`,payload); 
  } 
  postPhoneValidationCode(payload) {
    return axios.post(`account/phone_validation/code`,payload); 
  } 
  putAccount(payload) { 
    return axios.put(`account`,payload); 
  } 
  deleteAccount(payload) { 
    return axios.delete(`account`,{data: payload}); 
  }
  postAccountPassword(payload) { 
    return axios.post(`account/change-password`,payload); 
  } 
  deletePhone(payload) { 
    return axios.delete(`account/phone`,{data: payload}); 
  }
  acceptTerms() { 
    return axios.put('account/terms?accept=true'); 
  }
  putPasswordSafe(payload) { 
    return axios.put( `/account/locker-password`, payload); 
  }
  getTokenEmail() {
    return axios.get(`account/new-email-token`); 
  }
  getExtTokenEmail(payload) {
    console.log("🚀 ~ AccountService ~ getExtTokenEmail ~ payload:", payload)
    return axios.post(`account/ext-new-email-token`, payload); 
  }
  getTokenSms() {
    return axios.get(`account/new-sms-token`); 
  }
  postLoginSafe(payload) { 
    return axios.post(`report/locker/login`,payload); 
  } 
}

export default new AccountService();